import { useEffect, useState } from "react";
import { useGetPropertyOwners } from "../../api/v1";
import { PageScreen } from "../../types/search";
import { SelectOption } from "../../types/select";

type UsePropertyOwnersOptions = {
  screen: PageScreen;
  isEnabled?: boolean;
};

export const usePropertyOwnersOptions = (options: UsePropertyOwnersOptions) => {
  const { screen, isEnabled } = options;
  const [propertyOwnersOptions, setPropertyOwnersOptions] = useState<SelectOption[]>([]);

  const { propertyOwners, isLoadingPropertyOwners } = useGetPropertyOwners({ screen, isEnabled });

  useEffect(() => {
    if (!isEnabled) return;

    const options = propertyOwners.map((item) => ({
      label: item.ownerName,
      value: item.ownerName,
    }));

    setPropertyOwnersOptions(options);
  }, [isEnabled, propertyOwners]);

  return { propertyOwnersOptions, isLoadingPropertyOwners };
};
